export default {
  aside: {
    menu: {
      home: 'Home',
      creative: {
        name: 'Templates',
        playable: 'Playable Templates',
        video: 'Video Templates',
      },
      myproject: {
        name: 'My Projects',
        record: 'Screen Recording Projects',
        playable: 'Playable Projects',
        videoAndImage: 'Image Projects',
        export: 'Export & Download History',
      },
      service: {
        name: 'Creative Service',
        playable: 'Customized Playables',
        image: 'Customized Images & Videos',
      },
      myassets: {
        name: 'My Assets',
        asset: 'Creative Assets',
        template: 'Template Assets',
      },
      accountManagement: {
        name: 'Cost Center',
        billing: {
          usage: 'Package Usage',
          materials: 'Cost Consumption',
        },
        profile: 'Profile',
        reset: 'Password',
      },
      settings: {
        name: 'Account Settings',
        promote: 'Campaigns',
        record: 'Parameters for Recording',
      },
      poinitManagement: {
        title: 'PL Tracking Management',
      },
    },
  },
}
